import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { SegmentContext } from './Context';
import { ConnectedFlightsManagerLegDesktop } from '../../FlightsManagerLegDesktop';
import { CalendarType, FieldType, SearchSegment } from '../../../../models';
import { DateDesktop } from '../../DesktopFields';
import { displayFaresInCalendar, getSegments } from '../../../../redux/currentSearch/selectors';
import { ConnectedPaxSelectorDesktop } from '../../../PaxSelector';
import { ConnectedFaresProvider } from '../../../../components/Calendar/Context/FaresProvider';

export class SegmentManagerRoundTripDesktop extends PureComponent {
    state = {
        fieldFocused: false,
    };

    componentDidUpdate(prevProps) {
        const { segments } = this.props;
        const { fieldFocused } = this.state;
        const prevSegments = prevProps.segments;
        if (prevSegments !== segments) {
            const changedSegment = this.getChangedSegment(prevSegments);
            const changedPrevSegment = this.getChangedPrevSegment(prevSegments);
            if ((!fieldFocused || !this.cleanCityFocused(fieldFocused.field, changedSegment)) &&
                !this.swapWasClicked(changedPrevSegment, changedSegment)) {
                this.focusNext(segments);
            }
        }
    }

    getChangedPrevSegment(prevSegments) {
        const { segments } = this.props;
        return prevSegments.find((prevSegment, i) => segments[i] !== prevSegment);
    }

    getChangedSegment(prevSegments) {
        const { segments } = this.props;
        return segments.find((segment, i) => segment !== prevSegments[i]);
    }

    onChangeFocus = (field, focus, index) => {
        const leg = index ? index : 0;
        if (focus) {
            this.setState({
                fieldFocused: {
                    leg: leg,
                    field: field,
                },
            });
        } else {
            this.setState({ fieldFocused: false });
        }
    };

    onChangeFocusReturnLeg = (field, focus) => {
        this.onChangeFocus(field, focus, 1);
    };

    cleanCityFocused = (field, segment) => {
        return field === FieldType.DEPARTURE && !segment.origin || (field === FieldType.ARRIVAL && !segment.destination);
    };

    swapWasClicked = (prevSegment, segment) => {
        return segment && ((!!segment.origin === !!prevSegment.destination) ||
            (prevSegment.destination && prevSegment.destination.geoNodeId === 0)) &&
            segment.destination === prevSegment.origin &&
            segment.date === prevSegment.date;
    };

    focusNext = (segments) => {
        const nextField = this.nextFieldToBeFocused(segments);
        if (nextField) {
            this.onChangeFocus(nextField.field, true, nextField.leg);
        }
    };

    nextFieldToBeFocused = (segments) => {
        let nextField = null;
        if (!segments[0].origin) {
            nextField = { leg: 0, field: FieldType.DEPARTURE };
        } else if (!segments[0].destination) {
            nextField = { leg: 0, field: FieldType.ARRIVAL };
        } else if (!segments[0].date) {
            nextField = { leg: 0, field: FieldType.DATE };
        } else if (segments.length < 2 || !segments[1].date) {
            nextField = { leg: 1, field: FieldType.DATE };
        }
        return nextField;
    };

    render() {
        const { segments } = this.props;
        const { fieldFocused } = this.state;
        const firstIndex = 0;
        const secondIndex = 1;
        const fieldOpen = fieldFocused ? fieldFocused.field : null;
        const legFieldOpen = fieldFocused ? fieldFocused.leg : null;
        const [firstSegment, secondSegment] = segments;

        return (
            <div className="odf-space-inner-bottom-s">
                <div className="odf-row-fluid odf-row-top odf-row-nogutter">
                    <ConnectedFaresProvider
                        desktop
                        segmentId={firstSegment.id}
                        displayFaresInCalendar={this.props.displayFaresInCalendar}
                    >
                        <SegmentContext.Provider value={{ segment: firstSegment }}>
                            <ConnectedFlightsManagerLegDesktop
                                fieldFocused={fieldOpen}
                                onChangeFocus={this.onChangeFocus}
                            />
                            <div
                                className="odf-col"
                                data-testid="departure-date-picker"
                            >
                                <DateDesktop
                                    isDatesRangeShown
                                    open={fieldOpen === FieldType.DATE && legFieldOpen === firstIndex}
                                    onChangeFocus={this.onChangeFocus}
                                    placeholderKey="calendar.departureDate"
                                />
                            </div>
                        </SegmentContext.Provider>
                        <SegmentContext.Provider value={{ segment: secondSegment }}>
                            <div
                                className="odf-col odf-calendar-end"
                                data-testid="return-date-picker"
                            >
                                <DateDesktop
                                    isDatesRangeShown
                                    open={fieldOpen === FieldType.DATE && legFieldOpen === secondIndex}
                                    onChangeFocus={this.onChangeFocusReturnLeg}
                                    placeholderKey="calendar.returnDate"
                                    type={CalendarType.RETURN}
                                />
                            </div>
                        </SegmentContext.Provider>
                    </ConnectedFaresProvider>
                    <div className="odf-col odf-col-sm">
                        <ConnectedPaxSelectorDesktop />
                    </div>
                </div>
            </div>
        );
    }
}

SegmentManagerRoundTripDesktop.propTypes = {
    segments: PropTypes.arrayOf(SearchSegment),
    displayFaresInCalendar: PropTypes.bool.isRequired,
};

SegmentManagerRoundTripDesktop.defaultProps = {
    segments: [],
    displayFaresInCalendar: false,
};

const mapStateToProps = createStructuredSelector({
    segments: getSegments,
    displayFaresInCalendar: displayFaresInCalendar,
});

const ConnectedSegmentManagerRoundTrip = connect(mapStateToProps, {})(SegmentManagerRoundTripDesktop);
export { ConnectedSegmentManagerRoundTrip };
